import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import './LegalEntity.css';

const LegalEntity = () => (
  <>
    <Helmet>
      <title>Legal Entity Information | SPIRENEST TECHNOLOGIES</title>
      <link rel="canonical" href="https://spirenest.co/legal" />
      <meta name="description" content="Legal entity information for SPIRENEST TECHNOLOGIES, a registered trade name of PS NET IT SOLUTIONS LLC, a limited liability company registered in California, USA." />
      <meta name="robots" content="index, follow" />
    </Helmet>

    <section className="legal-hero">
      <div className="legal-hero-bg" />
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="text-center"
        >
          <h6 className="legal-eyebrow">TRANSPARENCY &amp; COMPLIANCE</h6>
          <h1 className="legal-hero-title">Legal Entity Information</h1>
          <p className="legal-hero-sub mx-auto">
            Full registration and contact details for the legal entity operating this website
            and its products.
          </p>
        </motion.div>
      </Container>
    </section>

    <section className="legal-body py-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: 'easeOut', delay: 0.1 }}
            >
              {/* Intro statement */}
              <div className="legal-card legal-card-intro mb-4">
                <p className="legal-intro-text">
                  <strong>SPIRENEST TECHNOLOGIES</strong> is a registered trade name
                  (&ldquo;Doing Business As&rdquo;) of{' '}
                  <strong>PS NET IT SOLUTIONS LLC</strong>, a limited liability company
                  registered in the State of California, United States.
                </p>
              </div>

              {/* Detail rows */}
              <div className="legal-card mb-4">
                <h2 className="legal-card-heading">Registration Details</h2>
                <div className="legal-detail-list">
                  <div className="legal-detail-row">
                    <span className="legal-detail-label">Registered Business Name</span>
                    <span className="legal-detail-value">PS NET IT SOLUTIONS LLC</span>
                  </div>
                  <div className="legal-detail-row">
                    <span className="legal-detail-label">Trade Name (DBA)</span>
                    <span className="legal-detail-value">SPIRENEST TECHNOLOGIES</span>
                  </div>
                  <div className="legal-detail-row">
                    <span className="legal-detail-label">State of Registration</span>
                    <span className="legal-detail-value">California, USA</span>
                  </div>
                  <div className="legal-detail-row">
                    <span className="legal-detail-label">Business Type</span>
                    <span className="legal-detail-value">Limited Liability Company (LLC)</span>
                  </div>
                </div>
              </div>

              <div className="legal-card mb-4">
                <h2 className="legal-card-heading">Contact Information</h2>
                <div className="legal-detail-list">
                  <div className="legal-detail-row">
                    <span className="legal-detail-label">Business Address</span>
                    <span className="legal-detail-value">
                      5886 Silhouette Ct,<br />
                      Dublin, California, USA 94568
                    </span>
                  </div>
                  <div className="legal-detail-row">
                    <span className="legal-detail-label">Contact Email</span>
                    <span className="legal-detail-value">
                      <a href="mailto:business@spirenest.co" className="legal-link">
                        business@spirenest.co
                      </a>
                    </span>
                  </div>
                  <div className="legal-detail-row">
                    <span className="legal-detail-label">Contact Phone</span>
                    <span className="legal-detail-value">
                      <a href="tel:+16509632560" className="legal-link">+1 (650) 963-2560</a>
                    </span>
                  </div>
                  <div className="legal-detail-row">
                    <span className="legal-detail-label">Website</span>
                    <span className="legal-detail-value">https://spirenest.co</span>
                  </div>
                </div>
              </div>

              {/* Products & agreements */}
              <div className="legal-card mb-4">
                <h2 className="legal-card-heading">Products &amp; Services</h2>
                <p className="legal-body-text">
                  Our products and services are offered under the{' '}
                  <strong>SPIRENEST TECHNOLOGIES</strong> brand. Current products include{' '}
                  <strong>ThinkingHub Assist</strong> — an AI-powered voice dictation and
                  voice assistant for Windows and macOS.
                </p>
                <p className="legal-body-text">
                  All legal agreements, contracts, and financial transactions are between the
                  customer and <strong>PS NET IT SOLUTIONS LLC</strong>.
                </p>
              </div>

              {/* Notice */}
              <div className="legal-notice">
                <p className="legal-notice-text">
                  This page is publicly accessible and intended to assist customers, partners,
                  and third-party reviewers in confirming the legal identity of the business
                  operating this website.
                </p>
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  </>
);

export default LegalEntity;
